var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _TrainClient_instances, _TrainClient_encryption, _TrainClient_httpClient, _TrainClient_awsConfig, _TrainClient_jasTrainingsURL, _TrainClient_getSignedHeaders;
import { normalizeCourses } from './utils';
import { awsConfigSchema, getUserCoursesParamsSchema, responseUserCoursesSchema } from './validation';
export class TrainClient {
    /**
     * @param encryption - Encryption API e.g. context.encryption
     * @param httpClient - HTTP Client API e.g. context.httpClient
     * @param awsConfig - AWS Config e.g. jas aws configuration from platform.json
     * @param jasBaseURL - Base URL for JAS API e.g. context.screening.baseUrl
     */
    constructor({ encryption, httpClient, awsConfig, jasBaseURL, }) {
        _TrainClient_instances.add(this);
        _TrainClient_encryption.set(this, void 0);
        _TrainClient_httpClient.set(this, void 0);
        _TrainClient_awsConfig.set(this, void 0);
        _TrainClient_jasTrainingsURL.set(this, void 0);
        __classPrivateFieldSet(this, _TrainClient_awsConfig, awsConfigSchema.parse(awsConfig), "f");
        __classPrivateFieldSet(this, _TrainClient_encryption, encryption, "f");
        __classPrivateFieldSet(this, _TrainClient_httpClient, httpClient, "f");
        __classPrivateFieldSet(this, _TrainClient_jasTrainingsURL, `${jasBaseURL}/training/lms/TRAIN/responder`, "f");
    }
    getUserCourses(params) {
        const parsedParams = getUserCoursesParamsSchema.parse(params);
        const uri = `${__classPrivateFieldGet(this, _TrainClient_jasTrainingsURL, "f")}/${encodeURIComponent(parsedParams.username)}?client=${encodeURIComponent(parsedParams.client)}`;
        const { code, body, errorBody } = __classPrivateFieldGet(this, _TrainClient_httpClient, "f").get(uri, __classPrivateFieldGet(this, _TrainClient_instances, "m", _TrainClient_getSignedHeaders).call(this, { httpMethod: 'GET', uri }));
        if (code !== 200) {
            throw Error(errorBody);
        }
        if (!body) {
            throw Error('No body');
        }
        const parsedBody = responseUserCoursesSchema.parse(body);
        return {
            email: parsedBody.Email,
            firstName: parsedBody.FirstName,
            lastName: parsedBody.LastName,
            username: parsedBody.Username,
            courses: normalizeCourses(parsedBody.Courses),
        };
    }
}
_TrainClient_encryption = new WeakMap(), _TrainClient_httpClient = new WeakMap(), _TrainClient_awsConfig = new WeakMap(), _TrainClient_jasTrainingsURL = new WeakMap(), _TrainClient_instances = new WeakSet(), _TrainClient_getSignedHeaders = function _TrainClient_getSignedHeaders({ httpMethod, uri }) {
    const config = Object.assign(Object.assign({}, __classPrivateFieldGet(this, _TrainClient_awsConfig, "f")), { uri,
        httpMethod });
    return __classPrivateFieldGet(this, _TrainClient_encryption, "f").awsSignV4(config);
};
